import React from 'react';
import { motion } from 'framer-motion';
const pairs = [{
  label: 'Bathroom Reset',
  before: 'https://cdn.magicpatterns.com/uploads/gp1CcJjiYxsiqT7YFxUtTY/ChatGPT_Image_Jun_11,_2026,_05_56_15_PM.png',
  after: 'https://cdn.magicpatterns.com/uploads/hzZU2KDyepiwJMMSLoYMMe/ChatGPT_Image_Jun_11,_2026,_05_56_23_PM.png'
}, {
  label: 'Post-Construction Reset',
  before: 'https://cdn.magicpatterns.com/uploads/oZUJcNfYV8jipx6C3nWJu2/ChatGPT_Image_Jun_11,_2026,_05_55_53_PM.png',
  after: 'https://cdn.magicpatterns.com/uploads/o7XUXw52yttqJ7oYxU1XH4/ChatGPT_Image_Jun_11,_2026,_05_56_03_PM.png'
}, {
  label: 'Luxury Interior Reset',
  before: 'https://cdn.magicpatterns.com/uploads/qKzKrTLKfvDD2tWZChsJLo/ChatGPT_Image_Jun_11,_2026,_06_33_48_PM_(1).png',
  after: 'https://cdn.magicpatterns.com/uploads/x9mMAvug2e95S8Wut1vUPz/ChatGPT_Image_Jun_11,_2026,_06_33_48_PM_(2).png'
}];
export function BeforeAfter() {
  return <section className="py-32 bg-paper" data-id="element-12">
      <div className="container mx-auto px-8 lg:px-12" data-id="element-13">
        <div className="mb-20 text-center" data-id="element-14">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-15">
            <div className="w-8 h-[1px] bg-lime" data-id="element-16"></div>
            <span className="text-ink/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-17">
              Transformations
            </span>
            <div className="w-8 h-[1px] bg-lime" data-id="element-18"></div>
          </div>
          <h2 className="text-4xl md:text-5xl text-ink font-light" data-id="element-19">
            See the <span className="font-medium" data-id="element-20">Reset.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 max-w-7xl mx-auto" data-id="element-21">
          {pairs.map((pair, index) => <motion.div key={pair.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2,
          ease: 'easeOut'
        }} className="group" data-id="element-22">
              <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-23">
                {/* BEFORE */}
                <div className="relative aspect-[4/5] overflow-hidden bg-graphite" data-id="element-24">
                  <img src={pair.before} alt={`${pair.label} — before`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-25" />
                  <div className="absolute bottom-6 left-6 bg-paper/90 backdrop-blur-sm text-ink px-4 py-2 text-[10px] uppercase tracking-[0.2em]" data-id="element-26">
                    Before
                  </div>
                </div>

                {/* AFTER */}
                <div className="relative aspect-[4/5] overflow-hidden bg-concrete/20" data-id="element-27">
                  <img src={pair.after} alt={`${pair.label} — after`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-28" />
                  <div className="absolute bottom-6 right-6 bg-ink/90 backdrop-blur-sm text-lime px-4 py-2 text-[10px] uppercase tracking-[0.2em]" data-id="element-29">
                    After
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between border-t border-concrete/50 pt-4" data-id="element-30">
                <p className="text-ink font-medium tracking-wide text-sm" data-id="element-31">
                  {pair.label}
                </p>
                <div className="w-1.5 h-1.5 rounded-full bg-lime" data-id="element-32"></div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}